import { typeRootState } from 'src/store';
import { useSelector } from 'react-redux';

export const useGetConfig = () => {
    const config = useSelector((state: typeRootState) => state.config);
    return config;
}
